exports.components = {
  "component---src-templates-page-tsx": () => import("./../../../src/templates/Page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-resolve-preview-tsx": () => import("./../../../src/templates/ResolvePreview.tsx" /* webpackChunkName: "component---src-templates-resolve-preview-tsx" */)
}

